export const APPOINTMENT_TEXT = 'Oil Change, tire services, brakes, batteries & more'
export const APPOINTMENT_TITLE = 'Schedule Appointment'
export const CONTACT_STORE_TITLE = 'Contact Your Store'
export const PHONE_TEXT = 'Phone:'
export const SELECT_STORE_TEXT = 'Select a Store'
